import React from "react";
import type { FormikProps } from "formik";

import FormikRadioGroup from "./FormikRadioGroup";

export interface FormikRadioGroupFieldOption {
  value: string;
  label: string;
}

export interface FormikRadioGroupFieldProps {
  formik: FormikProps<any>;
  name: string;
  label: string;
  options: FormikRadioGroupFieldOption[];
  disabled?: boolean;
  required?: boolean;
  row?: boolean;
  gridProps?: any;
  tooltipText?: string;
  tooltipKey?: string;
  tooltipUsePortal?: boolean;
  title?: string;
}

const FormikRadioGroupField: React.FC<FormikRadioGroupFieldProps> = ({
  formik,
  name,
  label,
  options,
  disabled,
  required,
  row,
  gridProps,
  tooltipText,
  tooltipKey,
  tooltipUsePortal,
  title,
}) => {
  const touched = Boolean((formik.touched as any)?.[name]);
  const rawError = touched ? (formik.errors as any)?.[name] : undefined;
  const values = formik.values;

  return (
    <FormikRadioGroup
      name={name}
      label={label}
      value={values[name] ?? ""}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      options={options}
      disabled={Boolean(disabled)}
      required={Boolean(required)}
      row={row}
      gridProps={gridProps}
      error={rawError ? rawError.toString() : undefined}
      tooltipText={tooltipText}
      tooltipKey={tooltipKey}
      tooltipUsePortal={tooltipUsePortal}
      title={title}
    />
  );
};

export default FormikRadioGroupField;